
/**
 * @Description //TODO 定义全局数据
 * @author Zhangbin
 * @date 2021/4/30 16:39
 * @Ver 1.3.1
 * @extends Vue
 */

import Vue from 'vue';
import Vuex from 'vuex';
import {checkEmpty} from '@/global/global-valid'

// 使用Vuex
Vue.use(Vuex);

// 向外暴露store
export default new Vuex.Store(
    {
        /**
         * @Des 缓存定义变量
         * @Auth Zhangbin
         * @Date 16:22 2021/4/30
         */
        state: {
            token: window.localStorage.getItem("token") ? window.localStorage.getItem("token") : '1',
            lang: window.localStorage.getItem("lang") ? window.localStorage.getItem("lang") : 'zh',
            loginDevice: window.localStorage.getItem("loginDevice") ? window.localStorage.getItem("loginDevice") : 1,
            userRole: window.localStorage.getItem("userRole") ? window.localStorage.getItem("userRole") : [],
            userAdminRole: window.localStorage.getItem("userAdminRole") ? window.localStorage.getItem("userAdminRole") : [],
            userProject: window.localStorage.getItem("userProject") ? window.localStorage.getItem("userProject") : [],
            userArea: window.localStorage.getItem("userArea") ? window.localStorage.getItem("userArea") : [],
            userName: window.localStorage.getItem("userName") ? window.localStorage.getItem("userName") : '',
            account: window.localStorage.getItem("account") ? window.localStorage.getItem("account") : '',
            accountId: window.localStorage.getItem("accountId") ? window.localStorage.getItem("accountId") : '',
            userRouter: window.localStorage.getItem("userRouter") ? window.localStorage.getItem("userRouter") : [],
            // 缓存 报警类型
			alarmStatus: window.localStorage.getItem("alarmStatus") ? window.localStorage.getItem("alarmStatus") : {},
			
            appId: window.localStorage.getItem("appId") ? window.localStorage.getItem("appId") : '',
            isAuthorized: window.localStorage.getItem("isAuthorized") ? window.localStorage.getItem("isAuthorized") : '',
            uuid: window.localStorage.getItem("uuid") ? window.localStorage.getItem("uuid") : '',
			currentProjectId: window.localStorage.getItem("currentProjectId") ? window.localStorage.getItem("currentProjectId") : '',
            // currentProjectId: 'd4a57f5075ed51dde9d49d45fca9090d',
            currentProjectName: window.localStorage.getItem("currentProjectName") ? window.localStorage.getItem("currentProjectName") : '',
            showType: window.localStorage.getItem("showType") ? window.localStorage.getItem("showType") : '',
            currentAreaId: window.localStorage.getItem("currentAreaId") ? window.localStorage.getItem("currentAreaId") : '',
            currentAreaName: window.localStorage.getItem("currentAreaName") ? window.localStorage.getItem("currentAreaName") : '',
            IPportPwd: window.localStorage.getItem("IPportPwd") ? window.localStorage.getItem("IPportPwd") : '',
            closeVoiceAccounts: window.localStorage.getItem("closeVoiceAccounts") ? window.localStorage.getItem("closeVoiceAccounts").split(';') : [],
            infoUri: ['/manager/info/user', '/manager/info/car', '/manager/device/tool'],
            homePage: '/manager/index',
            apiKey: '',
            fullscreen: (window.localStorage.getItem("fullscreen") === true || window.localStorage.getItem("fullscreen") === 'true'),
            autoLogin: false,// (window.localStorage.getItem("autoLogin") === true || window.localStorage.getItem("autoLogin") === 'true'),
            loginIp: window.localStorage.getItem("loginIp")?window.localStorage.getItem("loginIp"):'',
            loginCity: window.localStorage.getItem("loginCity")?window.localStorage.getItem("loginCity"):'',
            loginKey: window.localStorage.getItem("loginKey")?window.localStorage.getItem("loginKey"):'',
            tunnelAppIds: ['624b863a82a1e7bed3e066baaddf8a3e4', '624b863a82a1e7bed3e066baaddf8a3e5', '624b863a82a1e7bed3e066baaddf8a3e6'],
            authKey: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCvVjya063Fa24jTAhz3EF07eWDLZW5E0IavvzfHpv9kq3WS3FnkWZeoj0hZ//DYFtom0x961+HWZ55v4qZpMwEGRqYbQiaPkxc2WjpBQ/fRrF0lt5dZWHBbBXHzEa78J84T4PU9H053O/LFUfJNEW7n85RJ8MrtWUOOUoeAyYRjwIDAQAB',
            zoom: window.localStorage.getItem("zoom") ? window.localStorage.getItem("zoom") : 1,
            voiceAllowFlag: window.localStorage.getItem("voiceAllowFlag")==null?1:window.localStorage.getItem("voiceAllowFlag"),
            // layer position
            layerPosition: window.localStorage.getItem("layerPosition") ? window.localStorage.getItem("layerPosition") : '{}',
			
        },

        // 获取变量
        getters: {
            // 获取角色 id
            getUserRoleId: (state) => {
                let userRoleArray = typeof state.userRole == 'string' ? JSON.parse(state.userRole) : state.userRole;
                if(userRoleArray.length > 0){
                    return userRoleArray[0].id;
                }
                return '';
            },// getUserRoleId
            // 获取角色 名称
            getUserRoleName: (state) => {
                let userRoleArray = typeof state.userRole == 'string' ? JSON.parse(state.userRole) : state.userRole;
                if(userRoleArray.length > 0){
                    return userRoleArray[0].name;
                }
                return '';
            },// getUserRoleName
            // 移除关闭声音账户
            getAllowVoiceFlag: (state) => {
            	let closeVoiceAccounts = state.closeVoiceAccounts;
            	if (checkEmpty(closeVoiceAccounts)) {
            		closeVoiceAccounts = [];
            	}
            	let index = closeVoiceAccounts.indexOf(state.account);
            	return index == -1;
            },
            
        },

        /**
         * @Des 同步执行对变量进行的操作；
         * @Auth Zhangbin
         * @Date 16:22 2021/4/30
         */
        mutations: {
            // =============================================== set start ===============================================
            
            // 更新Token
            setToken: (state, data) => {
                window.localStorage.setItem("token", data)
                state.token = data
            },
            // 更新lang
            setLang: (state, data) => {
                window.localStorage.setItem("lang", data)
                state.lang = data
            },
            // 更新loginDevice
            setLoginDevice: (state, data) => {
                window.localStorage.setItem("loginDevice", data)
                state.loginDevice = data
            },
            // 更新用户角色
            setUserRole: (state, data) => {
                window.localStorage.setItem("userRole", data)
                state.userRole = data
            },
            // 更新用户角色
            setUserAdminRole: (state, data) => {
                window.localStorage.setItem("userAdminRole", data)
                state.userAdminRole = data
            },
            // 更新用户 项目
            setUserProject: (state, data) => {
                window.localStorage.setItem("userProject", data)
                state.userProject = data
            },
            // 更新用户 项目
            setUserArea: (state, data) => {
                window.localStorage.setItem("userArea", data)
                state.userArea = data
            },
            // 更新用户名
            setUserName: (state, data) => {
                window.localStorage.setItem("userName", data)
                state.userName = data
            },
            // 更新账户
            setAccount: (state, data) => {
                window.localStorage.setItem("account", data)
                state.account = data
            },
            // 更新账户id
            setAccountId: (state, data) => {
                window.localStorage.setItem("accountId", data)
                state.accountId = data
            },
            // 更新账户路由
            setUserRouter: (state, data) => {
                window.localStorage.setItem("userRouter", data)
                state.userRouter = data
            },
            
            // 更新 报警类型
            setAlarmStatus: (state, data) => {
                window.localStorage.setItem("alarmStatus", data)
                state.alarmStatus = data
            },

            // 更新 isAuthorized
            setIsAuthorized: (state, data) => {
                window.localStorage.setItem("isAuthorized", data)
                state.isAuthorized = data
            },
            // 更新 uuid
            setUuid: (state, data) => {
                window.localStorage.setItem("uuid", data)
                state.uuid = data
            },
            // 更新 currentProjectId
            setCurrentProjectId: (state, data) => {
                window.localStorage.setItem("currentProjectId", data)
                state.currentProjectId = data
            },
            // 更新 currentProjectName
            setCurrentProjectName: (state, data) => {
                window.localStorage.setItem("currentProjectName", data)
                state.currentProjectName = data
            },
            // 更新 showType
            setShowType: (state, data) => {
                window.localStorage.setItem("showType", data)
                state.showType = data
            },
            // 更新 currentAreaId
            setCurrentAreaId: (state, data) => {
                window.localStorage.setItem("currentAreaId", data)
                state.currentAreaId = data
            },
            // 更新 CurrentAreaName
            setCurrentAreaName: (state, data) => {
                window.localStorage.setItem("currentAreaName", data)
                state.currentAreaName = data
            },
            // 更新 IPportPwd
            setIPportPwd: (state, data) => {
                window.localStorage.setItem("IPportPwd", data)
                state.IPportPwd = data
            },
            // 更新关闭声音账户
            setCloseVoiceAccount: (state, data) => {
            	// 空值 默认值
            	if (checkEmpty(data)) {
            		data = state.account;
            		//return false;
            	}
            	let closeVoiceAccounts = state.closeVoiceAccounts;
            	if (checkEmpty(closeVoiceAccounts)) {
            		closeVoiceAccounts = [];
            	}
            	// 未存在
            	if (closeVoiceAccounts.indexOf(data) == -1) {
            		closeVoiceAccounts.push(data);
            		state.closeVoiceAccounts = Object.assign([], closeVoiceAccounts);
            		window.localStorage.setItem("closeVoiceAccounts", closeVoiceAccounts.join(';'));
            	}
            },
            // 更新 fullscreen
            setFullscreen: (state, data) => {
                window.localStorage.setItem("fullscreen", data)
                state.fullscreen = data
            },
            // 更新 autoLogin
            setAutoLogin: (state, data) => {
                window.localStorage.setItem("autoLogin", data)
                state.autoLogin = data
            },
            // 更新 loginIp
            setLoginIp: (state, data) => {
                window.localStorage.setItem("loginIp", data)
                state.loginIp = data
            },
            // 更新 loginKey
            setLoginKey: (state, data) => {
                window.localStorage.setItem("loginKey", data)
                state.loginKey = data
            },
            // 更新 loginCity
            setLoginCity: (state, data) => {
                window.localStorage.setItem("loginCity", data)
                state.loginCity = data
            },
            // 设置级别 zoom
            setZoom: (state,data) => {
                window.localStorage.setItem("zoom", data)
                state.zoom = data
            },
            // 设置声音 voiceAllowFlag
            setVoiceAllowFlag: (state,data) => {
                window.localStorage.setItem("voiceAllowFlag", data)
                state.voiceAllowFlag = data
            },
            // 设置 layer position
            setLayerPosition: (state,data) => {
                window.localStorage.setItem("layerPosition", data)
                state.layerPosition = data
            },
            // =============================================== set end ===============================================
            
            // =============================================== remove start ===============================================
            // 移除角色
            removeUserRole: state => {
                window.localStorage.removeItem("userRole")
                state.userRole = ''
            },
            // 移除角色
            removeUserAdminRole: state => {
                window.localStorage.removeItem("userAdminRole")
                state.userAdminRole = ''
            },
            // 移除项目
            removeUserProject: state => {
                window.localStorage.removeItem("userProject")
                state.userProject = ''
            },
            // 移除项目
            removeUserArea: state => {
                window.localStorage.removeItem("userArea")
                state.userArea = ''
            },
            // 移除用户名
            removeUserName: state => {
                window.localStorage.removeItem("userName")
                state.userName = ''
            },
            // 移除账户
            removeAccount: state => {
                window.localStorage.removeItem("account")
                state.account = ''
            },
            // 移除账户id
            removeAccountId: state => {
                window.localStorage.removeItem("accountId")
                state.accountId = ''
            },
            // 移除账户路由
            removeUserRouter: state => {
                window.localStorage.removeItem("userRouter")
                state.userRouter = ''
            },
            // 移除 isAuthorized
            removeIsAuthorized: state => {
                window.localStorage.removeItem("isAuthorized")
                state.isAuthorized = ''
            },
            // 移除 uuid
            removeUuid: state => {
                window.localStorage.removeItem("uuid")
                state.uuid = ''
            },
            // 移除 currentProjectId
            removeCurrentProjectId: state => {
                window.localStorage.removeItem("currentProjectId")
                state.currentProjectId = ''
            },
            // 移除 currentProjectName
            removeCurrentProjectName: state => {
                window.localStorage.removeItem("currentProjectName")
                state.currentProjectName = ''
            },
            // 移除 showType
            removeShowType: state => {
                window.localStorage.removeItem("showType")
                state.showType = ''
            },
            // 移除 currentAreaId
            removeCurrentAreaId: state => {
                window.localStorage.removeItem("currentAreaId")
                state.currentAreaId = ''
            },
            // 移除 currentAreaName
            removeCurrentAreaName: state => {
                window.localStorage.removeItem("currentAreaName")
                state.currentAreaName = ''
            },
            // 移除 IPportPwd
            removeIPportPwd: state => {
                window.localStorage.removeItem("IPportPwd")
                state.IPportPwd = ''
            },
            // 移除关闭声音账户 单个
            removeCloseVoiceAccount: (state, data) => {
            	// 空值 默认值
            	if (checkEmpty(data)) {
            		data = state.account;
            		//return false;
            	}
            	let closeVoiceAccounts = state.closeVoiceAccounts;
            	if (checkEmpty(closeVoiceAccounts)) {
            		closeVoiceAccounts = [];
            	}
            	let index = closeVoiceAccounts.indexOf(data);
            	// 未存在
            	if (index > -1) {
            		closeVoiceAccounts.splice(index, 1);
            		state.closeVoiceAccounts = Object.assign([], closeVoiceAccounts);
            		window.localStorage.setItem("closeVoiceAccounts", closeVoiceAccounts.join(';'));
            	}
            },
            // 移除关闭声音账户 全部
            removeCloseVoiceAccounts: state => {
            	window.localStorage.removeItem("closeVoiceAccounts")
                state.closeVoiceAccounts = []
            },
            // 移除 fullscreen
            removeFullscreen: (state, data) => {
                window.localStorage.removeItem("fullscreen")
                state.fullscreen = false
            },
            // 移除 removeAutoLogin
            removeAutoLogin: (state, data) => {
                window.localStorage.removeItem("autoLogin")
                state.autoLogin = false
            },
            // 移除 loginIp
            removeLoginIp: (state, data) => {
                window.localStorage.removeItem("loginIp")
                state.loginIp = ''
            },
            // 移除 loginKey
            removeLoginKey: (state, data) => {
                window.localStorage.removeItem("loginKey")
                state.loginKey = ''
            },
            // 移除 loginCity
            removeLoginCity: (state, data) => {
                window.localStorage.removeItem("loginCity")
                state.loginCity = ''
            },
            // 移除 voiceAllowFlag
            removeVoiceAllowFlag: (state, data) => {
                window.localStorage.removeItem("voiceAllowFlag")
                state.voiceAllowFlag = true
            },
            // 移除 layer position
            removeLayerPosition: (state, data) => {
                window.localStorage.removeItem("layerPosition")
                state.layerPosition = '{}'
            },
            // =============================================== remove end ===============================================
        },// mutations

        /**
         * @Des 异步执行对变量进行的操作；
         * @Auth Zhangbin
         * @Date 16:22 2021/4/30
         */
        actions: {
            commitToken: ({commit}, data) => {
                commit('setToken', data)
            },
            commitLang: ({commit}, data) => {
                commit('setLang', data)
            },
            commitLoginDevice: ({commit}, data) => {
                commit('setLoginDevice', data)
            },
            commitUserRole: ({commit}, data) => {
                commit('setUserRole', data)
            },
            commitUserAdminRole: ({commit}, data) => {
                commit('setUserAdminRole', data)
            },
            commitUserProject: ({commit}, data) => {
                commit('setUserProject', data)
            },
            commitUserArea: ({commit}, data) => {
                commit('setUserArea', data)
            },
            commitUserName: ({commit}, data) => {
                commit('setUserName', data)
            },
            commitRemoveUserName: ({commit}, data) => {
                commit('removeUserName', data)
            },
            commitAccount: ({commit}, data) => {
                commit('setAccount', data)
            },
            commitRemoveAccount: ({commit}, data) => {
                commit('removeAccount', data)
            },
            commitAccountId: ({commit}, data) => {
                commit('setAccountId', data)
            },
            commitRemoveAccountId: ({commit}, data) => {
                commit('removeAccountId', data)
            },
            commitUserRouter: ({commit}, data) => {
                commit('setUserRouter', data)
            },
            commitIsAuthorized: ({commit}, data) => {
                commit('setIsAuthorized', data)
            },
            commitUuid: ({commit}, data) => {
                commit('setUuid', data)
            },
            commitCurrentProjectId: ({commit}, data) => {
                commit('setCurrentProjectId', data)
            },
            commitCurrentProjectName: ({commit}, data) => {
                commit('setCurrentProjectName', data)
            },
            commitShowType: ({commit}, data) => {
                commit('setShowType', data)
            },
            commitCurrentAreaId: ({commit}, data) => {
                commit('setCurrentAreaId', data)
            },
            commitCurrentAreaName: ({commit}, data) => {
                commit('setCurrentAreaName', data)
            },
            commitIPportPwd: ({commit}, data) => {
                commit('setIPportPwd', data)
            },
			
			// 更新 报警类型
			commitAlarmStatus: ({commit}, data) => {
                commit('setAlarmStatus', data)
            },
			
            // 关闭声音账户 添加
            commitSCloseVoiceAccount: ({commit}, data) => {
            	commit('setCloseVoiceAccount', data)
            },
            // 关闭声音账户 移除 单个
            commitRCloseVoiceAccount: ({commit}, data) => {
            	commit('removeCloseVoiceAccount', data)
            },
            commitFullscreen: ({commit}, data) => {
                commit('setFullscreen', data)
            },
            commitAutoLogin: ({commit}, data) => {
                commit('setAutoLogin', data)
            },
            commitLoginIp: ({commit}, data) => {
                commit('setLoginIp', data)
            },
            commitLoginKey: ({commit}, data) => {
                commit('setLoginKey', data)
            },
            commitLoginCity: ({commit}, data) => {
                commit('setLoginCity', data)
            },
            commitZoom: ({commit}, data) => {
                commit('setZoom', data)
            },
            commitVoiceAllowFlag: ({commit}, data) => {
                commit('setVoiceAllowFlag', data)
            },
            commitLayerPosition: ({commit}, data) => {
                commit('setLayerPosition', data)
            },
        },// actions

    }
);



// WEBPACK FOOTER //
// ./src/store/index.js